import React from 'react'
import styled from 'styled-components'

import { formatTranscriptTimestamp } from '~/core/utils/dates'
import { Body01, LabelBold01 } from '~/components/common/typography'

const Container = styled.div`
  align-items: center;
  display: grid;
  grid-template-areas: 'photo name separator time' '. text text text';
  grid-template-columns: auto auto auto 1fr;
`

const Avatar = styled.img`
  border-radius: 50%;
  grid-area: photo;
  height: 32px;
  justify-self: center;
  margin-right: 16px;
  width: 32px;
`

const Name = styled(LabelBold01)`
  grid-area: name;
`

const Separator = styled(LabelBold01)`
  color: ${({ theme }) => theme._neo.textColor02};
  grid-area: separator;
  margin: 0 8px;
`

const Text = styled(Body01)`
  grid-area: text;
`

const Time = styled(LabelBold01)`
  color: ${({ theme }) => theme._neo.textColor02};
  grid-area: time;
`

const TranscriptEntry = ({
  authorId,
  avatarUrl,
  content,
  name,
  timestamp
}) => (
  <Container>
    <Avatar data-participant={authorId} src={avatarUrl} />
    <Name>{name}</Name>
    <Separator>&#8226;</Separator>
    <Time>{formatTranscriptTimestamp(timestamp)}</Time>
    <Text>{content}</Text>
  </Container>
)

export default TranscriptEntry
